package system.single

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import com.soywiz.korge.ui.*
import component.*

class PlayerCoinCollectionSystem(
    private val coinCounterTextView: UIText
): IteratingSystem( family{ all(PlayerComponent)}) {
    override fun onTickEntity(entity: Entity) {
        val playerComp = entity[PlayerComponent]

        coinCounterTextView.text = getTotalCoinsCount(playerComp.playerMetadata.playerPhysicState).toString()
    }

    private fun getTotalCoinsCount(physicState: PlayerPhysicState): Int {
        var result = physicState.coinsCount

        result += physicState.diamonds1Count * 2
        result += physicState.diamonds2Count * 3
        result += physicState.diamonds3Count * 4

        return result
    }
}
